import {
  COVER_DETAILS_BREAKDOWN_ROUTE,
  COVER_DETAILS_BUILDING_AND_CONTENTS_ROUTE,
  COVER_DETAILS_BUSINESS_INTERRUPTION_ROUTE,
  COVER_DETAILS_GLASS_ROUTE,
  COVER_DETAILS_LIABILITY_ROUTE,
  COVER_DETAILS_MONEY_ROUTE,
  COVER_DETAILS_PORTABLE_ITEMS_ROUTE,
  COVER_DETAILS_TAX_AUDIT_ROUTE,
  COVER_DETAILS_THEFT_ROUTE,
} from 'constants/routes';
import { Cover } from 'types/cover';

import type { CoverOptions } from '../hooks/useCoverOptions';
import { AppRoute } from '../types/types';
import { toSitecoreUrl } from './toSitecoreUrl';

/**
 * @description
 * maps cover id to cover position
 */

export const coverToPosition = {
  [Cover.Liability]: 0,
  [Cover.BuildingAndContents]: 1,
  [Cover.BusinessInterruption]: 2,
  [Cover.PortableItems]: 3,
  [Cover.Theft]: 4,
  [Cover.Money]: 5,
  [Cover.Glass]: 6,
  [Cover.Breakdown]: 7,
  [Cover.TaxAudit]: 8,
};

/**
 * @description
 * maps cover id to cover route
 */

export const coverToRoute: { [key in Cover]: AppRoute } = {
  [Cover.Liability]: COVER_DETAILS_LIABILITY_ROUTE,
  [Cover.BuildingAndContents]: COVER_DETAILS_BUILDING_AND_CONTENTS_ROUTE,
  [Cover.BusinessInterruption]: COVER_DETAILS_BUSINESS_INTERRUPTION_ROUTE,
  [Cover.PortableItems]: COVER_DETAILS_PORTABLE_ITEMS_ROUTE,
  [Cover.Theft]: COVER_DETAILS_THEFT_ROUTE,
  [Cover.Money]: COVER_DETAILS_MONEY_ROUTE,
  [Cover.Glass]: COVER_DETAILS_GLASS_ROUTE,
  [Cover.Breakdown]: COVER_DETAILS_BREAKDOWN_ROUTE,
  [Cover.TaxAudit]: COVER_DETAILS_TAX_AUDIT_ROUTE,
};

/**
 * @description
 * maps cover id to cover image
 */

export const typeToImageCovers: { [key in Cover]: string } = {
  [Cover.Liability]: toSitecoreUrl('8CC38B47218549BCA11EAAA326BD548F'),
  [Cover.BuildingAndContents]: toSitecoreUrl('B32521B460A741BB9235213891284926'),
  [Cover.BusinessInterruption]: toSitecoreUrl('64A31DA71F9347CBBB4C3AA498012050'),
  [Cover.PortableItems]: toSitecoreUrl('AEA52AA3FEA0458F93A69B0AC86B54AB'),
  [Cover.Theft]: toSitecoreUrl('26E42AA4963F4E04BCD9E28A586D25C1'),
  [Cover.Money]: toSitecoreUrl('237BFBB9B1FD4445A72A60F2B69F2C2F'),
  [Cover.Glass]: toSitecoreUrl('0BF2234F5A924108B2122C70DBC7C363'),
  [Cover.Breakdown]: toSitecoreUrl('F8E31B5206AF46C19793F2C2B1633A1C'),
  [Cover.TaxAudit]: toSitecoreUrl('D73D2D41546F44D9844AA49210F4D867'),
};

/**
 * @description
 * cover utility functions
 */

export const isNoDuplicate = (arr: Cover[], value: Cover) => !arr.includes(value);
export const coverExists = (arr: Cover[], value: Cover) => arr.includes(value);
export const removeCoverByPosition = (arr: Cover[], value: Cover) =>
  arr.splice(arr.indexOf(value), 1);
export const sortCovers = (arr: Cover[], coverOptions: CoverOptions | undefined) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  coverOptions?.map((c: { id: any }) => c.id).filter((c: Cover) => arr.indexOf(c) >= 0) || [];
